<template>
  <v-app id="reset-password">
    <v-main>
      <v-container class="fill-height" fluid
        :style="{ background: 'url(' + require('@/assets/bg.jpg') + ') center center / cover' }">
        <v-row align="center" justify="center">
          <v-overlay z-index="0" opacity="0.6" absolute></v-overlay>
          <v-col v-if="$route.query.token" cols="12" sm="8" md="4" lg="4" style="z-index: 1">
            <v-card class="elevation-3 pa-2 rounded-lg">
              <v-card-title class="justify-center mb-4">
                <div class="layout column align-center">
                  <img src="@/assets/logo.png" alt="Logo" width="120" height="120" class="mb-4">
                  <h2 class="text-h5 font-weight-bold primary--text">Establecer nueva contraseña</h2>
                </div>
              </v-card-title>

              <v-card-text>

                <v-form ref="passwordForm" v-model="passwordValid">
                  <!-- Campo de nueva contraseña -->
                  <v-text-field v-model="fields.newPassword" :disabled="loading"
                    :type="showNewPassword ? 'text' : 'password'" :rules="validations.newPassword"
                    :error-messages="errors.newPassword" label="Nueva Contraseña" outlined dense
                    prepend-inner-icon="mdi-lock-outline" :append-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showNewPassword = !showNewPassword" placeholder="Ingrese su nueva contraseña"
                    class="mb-4"></v-text-field>

                  <!-- Campo de confirmación de contraseña -->
                  <v-text-field v-model="fields.newPasswordConfirm" :disabled="loading"
                    :type="showNewPasswordConfirm ? 'text' : 'password'" :rules="validations.newPasswordConfirm"
                    :error-messages="errors.newPasswordConfirm" label="Confirmar Nueva Contraseña" outlined dense
                    prepend-inner-icon="mdi-lock-check-outline"
                    :append-icon="showNewPasswordConfirm ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showNewPasswordConfirm = !showNewPasswordConfirm"
                    placeholder="Repita su nueva contraseña"></v-text-field>

                  <!-- Indicador de fortaleza de contraseña -->
                  <v-card v-if="fields.newPassword" outlined class="mb-4 pa-3">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-center mb-2">
                        <div class="subtitle-2 font-weight-medium mr-2">Fortaleza:</div>
                        <div class="ml-2 font-weight-medium" :class="`${passwordStrength.color}--text`">
                          {{ passwordStrength.text }}
                        </div>
                      </div>
                      <v-progress-linear :value="passwordStrength.score * 25" :color="passwordStrength.color" height="8"
                        rounded class="mb-1"></v-progress-linear>

                      <div class="d-flex flex-wrap mt-3">
                        <v-chip small class="mr-1 mb-1" :color="fields.newPassword.length >= 8 ? 'success' : 'grey'"
                            :text-color="fields.newPassword.length >= 8 ? 'success' : ''" outlined>
                            <v-icon left x-small>{{ fields.newPassword.length >= 8 ? 'mdi-check' : 'mdi-close'
                              }}</v-icon>
                            8+ caracteres
                          </v-chip>
                          <v-chip small class="mr-1 mb-1"
                            :color="/[0-9]/.test(fields.newPassword) ? 'success' : 'grey'"
                            :text-color="/[0-9]/.test(fields.newPassword) ? 'success' : ''" outlined>
                            <v-icon left x-small>{{ /[0-9]/.test(fields.newPassword) ? 'mdi-check' : 'mdi-close'
                              }}</v-icon>
                            Número
                          </v-chip>
                            <v-chip small class="mr-1 mb-1"
                            :color="/[a-zA-Z]/.test(fields.newPassword) ? 'success' : 'grey'"
                            :text-color="/[a-zA-Z]/.test(fields.newPassword) ? 'success' : ''" outlined>
                            <v-icon left x-small>{{ /[a-zA-Z]/.test(fields.newPassword) ? 'mdi-check' : 'mdi-close'
                              }}</v-icon>
                            Letra
                            </v-chip>
                      </div>
                    </div>
                  </v-card>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading" :disabled="loading || !isPasswordFormValid"
                  @click="changePassword" block>
                  <v-icon left>mdi-lock-reset</v-icon>
                  Cambiar Contraseña
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col v-else cols="12" sm="8" md="4" lg="4" style="z-index: 1">
            <v-card class="elevation-3 pa-2 rounded-lg">
              <v-card-title class="justify-center mb-4">
                <div class="layout column align-center">
                  <img src="@/assets/logo.png" alt="Logo" width="120" height="120" class="mb-4">
                  <h2 class="text-h5 font-weight-bold primary--text">Introduzca su email</h2>
                </div>
              </v-card-title>

              <v-card-text>

                <v-form ref="requestForm" v-model="emailValid">
                  <!-- Campo de nueva contraseña -->
                  <v-text-field v-model="fields.email" :disabled="loading"
                    type="email" :rules="validations.email"
                    :error-messages="errors.email" label="Email" outlined dense
                    prepend-inner-icon="mdi-email" placeholder="Ingrese su email">
                  </v-text-field>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading" :disabled="loading || !isEmailFormValid"
                  @click="requestPassword" block>
                  <v-icon left>mdi-lock-reset</v-icon>
                  Solicitar Email
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import MobileDetect from 'mobile-detect'
import { mapGetters } from 'vuex/dist/vuex.common.js'
import UserService from '@/services/UserService'

export default {
  data: () => ({
    loading: false,
    md: new MobileDetect(navigator.userAgent),
    showNewPassword: false,
    showNewPasswordConfirm: false,
    passwordValid: true,
    emailValid: true,

    // Campos del formulario
    fields: {
      newPassword: '',
      newPasswordConfirm: '',
      email: ''
    },

    // Errores
    errors: {
      newPassword: [],
      newPasswordConfirm: [],
      email: []
    }
  }),

  computed: {
    ...mapGetters(['CURRENT_USER']),

    validations () {
      return {
        newPassword: [
          v => !!v || 'La nueva contraseña es requerida',
          v => v.length >= 8 || 'La nueva contraseña debe tener al menos 8 caracteres',
          v => /\d/.test(v) || 'La contraseña debe incluir al menos un número',
          v => /[a-zA-Z]/.test(v) || 'La contraseña debe incluir al menos una letra'
        ],
        newPasswordConfirm: [
          v => !!v || 'La confirmación de la nueva contraseña es requerida'
        ],
        email: [
          v => !!v || 'El email es requerido',
          v => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return emailRegex.test(v) || 'Email no válido'
          }
        ]
      }
    },

    isPasswordFormValid () {
      return (
        this.passwordValid &&
        this.fields.newPassword &&
        this.fields.newPasswordConfirm &&
        this.fields.newPassword === this.fields.newPasswordConfirm
      )
    },

    isEmailFormValid () {
      return (
        this.emailValid &&
        this.fields.email &&
        this.validations.email.every(rule => rule(this.fields.email) === true)
      )
    },

    passwordStrength () {
      if (!this.fields.newPassword) {
        return { score: 0, text: 'Ninguna', color: 'grey' }
      }

      const password = this.fields.newPassword
      let score = 0

      // Longitud
      if (password.length >= 12) score += 2
      else if (password.length >= 8) score += 1

      // Complejidad
      if (/[A-Z]/.test(password)) score += 1
      if (/[a-z]/.test(password)) score += 1
      if (/\d/.test(password)) score += 1
      if (/[^A-Za-z0-9]/.test(password)) score += 1

      // Mapear a nivel de fortaleza
      let result = { score: 0, text: 'Muy débil', color: 'red' }

      if (score >= 5) {
        result = { score: 4, text: 'Muy fuerte', color: 'success' }
      } else if (score === 4) {
        result = { score: 3, text: 'Fuerte', color: 'light-green' }
      } else if (score === 3) {
        result = { score: 2, text: 'Media', color: 'amber' }
      } else if (score === 2) {
        result = { score: 1, text: 'Débil', color: 'orange' }
      }

      return result
    }
  },

  watch: {
    'fields.newPasswordConfirm': function (newPasswordConfirm) {
      if (newPasswordConfirm && newPasswordConfirm === this.fields.newPassword) {
        this.errors.newPasswordConfirm = []
      } else if (newPasswordConfirm) {
        this.errors.newPasswordConfirm = ['Las contraseñas no coinciden']
      }
    }
  },

  methods: {
    async changePassword () {
      if (!this.isPasswordFormValid) return

      this.loading = true
      try {
        let payload = {
          'password': this.fields.newPassword,
          'token': this.$route.query.token
        }
        const response = await UserService.resetPassword(payload)

        if (response.data.success && response.data.data) {
          this.$toast.success('Contraseña cambiada con éxito')

          // Limpiar campos después de cambiar la contraseña
          // this.fields.newPassword = ''
          // this.fields.newPasswordConfirm = ''
          // this.errors.newPassword = []
          // this.errors.newPasswordConfirm = []
          // this.validations.newPassword = []
          // this.validations.newPasswordConfirm = []

          // Redirigir después de un breve retraso
          setTimeout(() => {
            this.$router.push({ name: 'Login' })
          }, 2000)
        } else {
          this.$toast.error('Error al cambiar la contraseña')
        }
      } catch (error) {
        console.error('Error al cambiar la contraseña:', error)
        this.$toast.error('Ocurrió un error al cambiar la contraseña')
      } finally {
        this.loading = false
      }
    },
    async requestPassword () {
      if (!this.isEmailFormValid) return

      this.loading = true
      try {
        const response = await UserService.requestResetPassword({ 'email': this.fields.email })

        if (response.data.success && response.data.data) {
          this.$toast.success('Correo enviado con éxito. Revise su bandeja de entrada.')

          // Limpiar campos después de cambiar la contraseña
          // this.fields.email = ''
          // this.validations.email = []
          // this.errors.email = []

          // Redirigir después de un breve retraso
          setTimeout(() => {
            this.$router.push({ name: 'Login' })
          }, 2000)
        } else {
          this.$toast.error('Error al enviar el correo')
        }
      } catch (error) {
        console.error('Error al enviar el correo:', error)
        this.$toast.error('Ocurrió un error al enviar el correo')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease;
  border-radius: 12px !important;
}

.v-chip {
  font-size: 12px !important;
}

.theme-color-preview {
  border-radius: 4px;
  overflow: hidden;
}
</style>
